<template>
  <v-footer>
    <v-container class="pa-16">
      <!-- <v-spacer></v-spacer> -->
      <v-row class="footer-nav">

        <v-col md="3" class="col-flex-basis-1">
          <dl>
            <dt class="subtitle-1 font-weight-medium">Products</dt>
            <dd
              v-for="item in menu_products"
              :key="item.text"
              :to="item.to"
            >
              <a
                v-if="item.highlight != 'true'"
                :href="item.to"
                class="caption font-weight-regular"
                style="color: #000000DE;"
                >
                {{ item.text }}
              </a>
              <a
                v-else
                :href="item.to"
                class="caption font-weight-bold primary--text"
                style="color: #000000DE;"
                >
                {{ item.text }}
              </a>
            </dd>
          </dl>
        </v-col>

        <v-col md="3" class="col-flex-basis-1">
          <dl>
            <dt class="subtitle-1 font-weight-medium">SecOps Automation</dt>
            <dd
              v-for="item in menu_usecases"
              :key="item.text"
              :to="item.to"
            >
              <a
                :href="item.to"
                class="caption font-weight-regular"
                style="color: #000000DE;"
                >
                {{ item.text }}
              </a>
            </dd>
          </dl>
        </v-col>
        <v-responsive
          width="100%"
          v-if="$vuetify.breakpoint.smAndDown"
        ></v-responsive>

        <v-col md="3" class="col-flex-basis-1">
          <dl>
            <dt class="subtitle-1 font-weight-medium">Resources</dt>
            <dd
              v-for="item in menu_resources"
              :key="item.text"
              :to="item.to"
            >
              <a
                v-if="item.highlight != 'true'"
                :href="item.to"
                class="caption font-weight-regular"
                style="color: #000000DE;"
                >
                {{ item.text }}
              </a>
              <a
                v-if="item.highlight == 'true'"
                :href="item.to"
                class="caption font-weight-bold primary--text"
                >
                {{ item.text }}
              </a>
            </dd>
          </dl>
        </v-col>

        <v-col md="3" class="col-flex-basis-1">
          <dl>
            <dt class="subtitle-1 font-weight-medium">Company</dt>
            <dd
              v-for="item in menu_company"
              :key="item.text"
              :to="item.to"
            >
              <a
                :href="item.to"
                class="caption font-weight-regular"
                style="color: #000000DE;"
                >
                {{ item.text }}
              </a>
            </dd>
          </dl>
        </v-col>
      </v-row>

      <v-row class="footer-press" align="center">
        <v-col class="footer-logo-address" cols="7">
          <img :src="images.logo" width="150"/>
          <div class="caption">
            1 rue Michelet,<br/>
            92130 Issy-les-Moulineaux, France
          </div>
        </v-col>
        <v-col cols="5" align="right">
          <v-btn
            v-for="item in social_links"
            :key="item.to"
            icon
            :href="item.to"
          >
            <v-icon size="24px">{{ item.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="footer-copyright">
        <v-col>
          <div class="caption">&copy; 2018-{{ new Date().getFullYear() }} - Patrowl SAS. All rights reserved.</div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'PublicAppLayoutFooter',
  data: () => ({
    images: {
      // logo: require('@/assets/img/logo-owl-small.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
    social_links: [
      { icon: 'mdi-twitter', to: 'https://twitter.com/patrowl_io'},
      { icon: 'mdi-linkedin', to: 'https://www.linkedin.com/company/patrowl/'},
      // { icon: 'mdi-youtube', to: 'https://www.youtube.com/watch?v=V6SJtuj77jU&t=6s'}
      { icon: 'mdi-youtube', to: 'https://www.youtube.com/watch?v=hEPF_6HGDY0'}
    ],
    menu_products: [
      { text: 'Offensive Security', to: 'https://patrowl.io', highlight: 'true' },
      { text: 'Vulnerability & Exploit Monitoring', to: '/' },
      // { text: 'PatrowlManager', to: '/products/manager' },
    ],
    menu_usecases: [
      { text: 'Vulnerability Management', to: '/' },
      { text: 'Exploit Database', to: '/' },
      { text: 'Cyber Threat Intelligence', to: '/' },
      { text: 'AppSec DevSecOps', to: '/' },
      { text: 'REST-API', to: 'https://github.com/Patrowl/PatrowlHears4py' },
    ],
    menu_resources: [
      { text: 'MSSP and Partners', to: '/about-us#section-about-contacts' },
      { text: 'Pricing', to: '/#pricing' },
      { text: 'Request a demo', to: '/get-started', highlight: 'true' },
      { text: 'Legal & Security', to: '/legal' },
      { text: 'GitHub', to: 'https://github.com/Patrowl/PatrowlHears' },
    ],
    menu_company: [
      { text: 'About us', to: 'https://patrowl.io/about-us' },
      { text: 'Contact', to: '/get-started' },
    ]
  }),
  mounted() {
    let hubspot_chatflow = document.createElement('script')
    hubspot_chatflow.setAttribute('src', 'https://js.hs-scripts.com/7593890.js')
    document.head.appendChild(hubspot_chatflow);
  }
}
</script>

<style>
dd > a {
  text-decoration: none;
}
.footer-press {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 30px;
}
</style>
